package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val ToolbarIconContainerStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("width", 22.px)
            property("height", 22.px)
        }
    }
    Breakpoint.MD {
        Modifier.styleModifier {
            property("width", 26.px)
            property("height", 26.px)
        }
    }
    Breakpoint.LG {
        Modifier.styleModifier {
            property("width", 32.px)
            property("height", 32.px)
        }
    }
}

val ToolbarIconInnerStyle = CssStyle {
    base {
        Modifier.styleModifier { property("font-size", 12.px) }
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("font-size", 15.px) }
    }
    Breakpoint.LG {
        Modifier.styleModifier { property("font-size", 18.px) }
    }
}

val TextEditorSeparatorStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(1.px)
    }
}

val TextEditorToolbarRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(
                leftRight = 6.px,
                topBottom = 4.px
            )
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
                property("flex-wrap", "wrap")
                property("row-gap", "6px")
            }
    }

    Breakpoint.MD {
        Modifier.padding(
            leftRight = 6.px,
            topBottom = 8.px
        )
    }
}

val VerticalDividerStyle = CssStyle {
    base {
        Modifier
            .width(1.px)
            .height(14.px)
    }
    Breakpoint.MD {
        Modifier
            .width(1.px)
            .height(25.px)
    }
}

val AlignmentOptionIconStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .margin(left = 5.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(16.px)
            .margin(left = 10.px)
    }
}